
import { Component, Vue, Prop } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WebsiteMigration } from '@/services/WebsiteMigrations/interfaces';
import { Website, WebsiteGroup } from '@/services/Website/interfaces';
import { ServerInterface } from '@/services/Server/Interfaces';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class RetryMigrationDialog extends Vue {
  @Prop() migration!: WebsiteMigration;

  @Prop() servers!: ServerInterface[];

  @Prop() sourceWebsite!: Website;

  @Prop() sourceServer!: ServerInterface;

  @Prop({ required: false }) targetGroup!: WebsiteGroup;

  @Prop({ required: false }) targetServer!: ServerInterface;

  public targetServerId: string = '';

  public visible: boolean = true;

  public serverDisabled: boolean = false;

  public get message(): string {
    return `Are you sure you want to retry migration of website with domain "${this.sourceWebsite.domain}" from server "${this.sourceServer.hostname}" to server:`;
  }

  public get valid(): boolean {
    return !!this.targetServerId?.length;
  }

  public created(): void {
    if (this.targetServer && this.targetServer?._id) {
      this.targetServerId = this.targetServer._id;
      this.serverDisabled = true;
    }
  }

  public retryMigration(): void {
    const targetServer = this.servers.find((s) => s._id === this.targetServerId);
    if (!targetServer) {
      this.$errorDialog.show('Target server not found!');

      return;
    }

    this.$emit(
      'retryMigration',
      this.migration,
      this.sourceWebsite,
      this.sourceServer,
      targetServer,
      this.targetGroup,
    );

    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');
    this.visible = false;
  }
}
